<template>
  <Search />
  <Table />
</template>
<script>
import {
  language_key_operate_lang_field_get,
  language_key_list_get,
  common_info_get,
  language_key_query_id_get
} from 'server/modules/351.js'
import { provide, onMounted, reactive, toRefs } from 'vue'
import Search from './components/Search'
import Table from './components/Table'
import { message } from 'ant-design-vue'
export default {
  components: {
    Search,
    Table
  },
  setup() {
    // const store = useStore()
    const state = reactive({
      dataList: [],
      fields: [],
      systems: [],
      // 语言筛选条件
      lang: [],
      // 语言 新增和编辑的语言列
      langField: {},
      visible: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      updateTime: [],
      params: {
        keyName: null,
        languageId: null,
        valueName: '',
        systemId: null,
        userName: '',
        updateTimeStart: null,
        updateTimeEnd: null
      },
      formData: {
        systemId: null,
        keyName: '',
        id: ''
      },

      // 清空
      setEmpty: () => {
        state.formData = {
          countryId: null,
          regionNameEn: '',
          cityNameEn: '',
          postalCode: '',
          enabled: null
        }
      },

      setAttrs: (name, value) => {
        state[name] = value
      },

      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
        state.getRegionList()
      },
      onShowSizeChange(current, pageSize) {
        state.pageNum = current
        state.pageSize = pageSize
        state.getRegionList()
      },
      async getLang() {
        const { success, data } = await language_key_operate_lang_field_get()
        if (success) {
          state.langField = data
        }
      },

      /**
       * 查询地址列表
       */
      getRegionList: async () => {
        const { updateTime } = state
        if (updateTime.length) {
          state.params.updateTimeStart = updateTime[0] || ''
          state.params.updateTimeEnd = updateTime[1] || ''
        } else {
          state.params.updateTimeStart = ''
          state.params.updateTimeEnd = ''
        }
        const { success, data, retInfo } = await language_key_list_get({
          ...state.params,
          ...{
            pageNum: state.pageNum,
            pageSize: state.pageSize
          }
        })
        if (success) {
          const { list, total, field } = data
          state.fields = field
          state.dataList = list
          state.total = total
        } else {
          message.error(retInfo)
        }
      },
      /**
       * 获取筛选条件基础信息
       */
      getCommonInfo: async () => {
        const { success, data } = await common_info_get().catch(() => {})
        if (success) {
          state.systems = data.menuSystem
          state.lang = data.lang
        }
      },
      // 编辑词条
      queryDetail: async params => {
        const { success, retInfo, data } = await language_key_query_id_get({
          id: params.id
        })
        if (success) {
          state.visible = true
          state.formData = data
        } else {
          message.error(retInfo)
        }
      }
    })

    onMounted(() => {
      const { getLang, getRegionList, getCommonInfo } = state
      getCommonInfo()
      getLang()
      getRegionList()
    })
    provide('state', state)

    return {
      ...toRefs(state)
    }
  }
}
</script>
